import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import SupportPopup from 'apps/auth/components/utils/popup/SupportPopup';
import { PLUS_SEND_TRANSFER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_SEND_LINK } from 'apps/auth/constants/UrlConstants';

import FeeFreeTransferBenefitsModal from './FeeFreeTransferBenefitsModal';

const MakingTransfersPopup = (props) => {
    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton
                iconName="transfers"
                href={AUTH_SEND_LINK}
                text={props.sendTransfer}
                onClick={() => {
                    amplitude.getInstance().logEvent(PLUS_SEND_TRANSFER_CLICKED);
                    props.popupRef?.current?.close();
                }}
            />
            <PopupButton
                iconName="info-rounded"
                text={props.feeFreeTransfers}
                onClick={() => {
                    props.toggleModal(true, <FeeFreeTransferBenefitsModal popupRef={props.popupRef} />);
                    props.popupRef?.current?.close();
                }}
            />
            <PopupButton
                iconName="lifebuoy"
                text={props.support}
                onClick={(e) => {
                    e.preventDefault();
                    props.popupRef?.current?.close();
                    props.popupRef?.current?.open(<SupportPopup popupRef={props.popupRef} />);
                }}
            />
        </SimplePopup>
    );
};
MakingTransfersPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    feeFreeTransfers: PropTypes.string,
    sendTransfer: PropTypes.string,
    support: PropTypes.string,
};
export default connect(null, { toggleModal })(MakingTransfersPopup);
